import { useInfiniteQuery } from "@tanstack/react-query";
import { ApiGetUserDynamicRewardClaimRecords } from "@/api";
import type { GetUserDynamicRewardClaimRecordsResponse } from "@/api/types";

const PAGE_SIZE = 100;

export function useUserDynamicRewardClaimRecords(coinContract?: string) {
  return useInfiniteQuery({
    queryKey: ["userDynamicRewardClaimRecords", coinContract ?? ""],
    queryFn: async ({
      pageParam,
    }): Promise<GetUserDynamicRewardClaimRecordsResponse> => {
      const res = await ApiGetUserDynamicRewardClaimRecords({
        page: pageParam,
        pageSize: PAGE_SIZE,
        coinContract,
      });
      console.log("useUserDynamicRewardClaimRecords", res.data);
      return res.data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const fetched = allPages.reduce(
        (sum, page) => sum + (page.records?.length ?? 0),
        0
      );
      if (fetched >= (lastPage.total ?? 0)) return undefined;
      return allPages.length + 1;
    },
  });
}
